import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs';
import { OverviewService } from './overview.service';
import { RouteContextService } from '@context/old_index';

@Injectable()
export class EntityRouteGuard  {

  constructor(
    private readonly routeContextService: RouteContextService,
    private readonly overviewService: OverviewService,
    private readonly router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const routeContext = this.routeContextService.getRouteContextFromRouteSnapshot(route);
    if (!routeContext) { // only consider routes with entityType data
      return of(true);
    }
    return this.overviewService.getOverviewConfiguration().pipe(
      take(1),
      switchMap(config => {
          var result = config != undefined && config.AvailableTiles.find(t => t.Name.replace('DashboardComponent', '') === routeContext.routeContextItemType ) != undefined;
        // https://github.com/angular/angular/issues/16211 prevents us from falling through to 404
        if (result === false) {
          this.router.navigateByUrl('/main');
        }
        return of(result);
      }));
  }
}
